import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AdminFunctionsRoutingModule } from './admin-functions-routing.module';
import { PrimengModule } from '../primeng/primeng.module';
import { SystemConfigurationComponent } from './system-configuration/components/system-configuration.component';
import { PartnerComponent } from './partner/partner.component';
import { PartnerConfigurationComponent } from './partner-specific-configuration/components/partner-configuration.component';
import { SharedModule } from '../shared/shared.module';
import { InternalUsersComponent } from './internal-users/components/internal-users/internal-users.component';
import { UpdateUserDialogComponent } from './internal-users/components/update-user-dialog/update-user-dialog.component';
import { UpdatePasswordComponent } from './topcon-configuration/components/update-password/update-password.component';
import { ServiceLevelConfigDialogComponent } from './topcon-configuration/components/service-level-config-dialog/service-level-config-dialog.component';
import { UnsavedServiceLevelConfigDialogComponent } from './topcon-configuration/components/service-level-config-dialog/unsaved-service-level-config-dialog.component';
import { TestActivationConfigDialogComponent } from './topcon-configuration/components/test-activation-config-dialog/test-activation-config-dialog.component';
import { TopconConfigurationComponent } from './topcon-configuration/components/topcon-configuration/topcon-configuration.component';

@NgModule({
    declarations: [
        TopconConfigurationComponent,
        ServiceLevelConfigDialogComponent,
        UnsavedServiceLevelConfigDialogComponent,
        SystemConfigurationComponent,
        PartnerComponent,
        PartnerConfigurationComponent,
        TestActivationConfigDialogComponent,
        InternalUsersComponent,
        UpdateUserDialogComponent,
        UpdatePasswordComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PrimengModule,
        AdminFunctionsRoutingModule,
        HttpClientModule,
        SharedModule
    ]
})
export class AdminFunctionsModule {}
